// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/widgets/action/ignorance-board/ignorance-board.component.css
// module id = 756
// module chunks = 0